export const isLocalDev = process.env.REACT_APP_APP_ENVIRONMENT === "LOCAL";
